import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'navigation-active-state',
    templateUrl: './navigation-active-state.component.html',
    styleUrls: ['./navigation-active-state.component.scss'],
    standalone: false
})
export class NavigationActiveStateComponent implements OnInit {
  @Input() item: any;
  @Input() app: any;
  @Input() type: any;
  @Input() package: any;

  ngOnInit() {
  }

  isInSeason(fromRaw, toRaw, date = new Date()) {
    const parse = d => {
      const dt = d?.getMonth ? d : new Date(d);
      return { m: dt.getMonth(), d: dt.getDate() };
    };
    const from = fromRaw ? parse(fromRaw) : null;
    const to = toRaw ? parse(toRaw) : null;
    if (!from || !to) return true;
    const now = { m: date.getMonth(), d: date.getDate() };
    const before = (a, b) => a.m < b.m || (a.m === b.m && a.d <= b.d);
    const after  = (a, b) => a.m > b.m || (a.m === b.m && a.d >= b.d);
    return before(from, to) ? (after(now, from) && before(now, to)) : (after(now, from) || before(now, to));
  }


  public checkActive() {
    const app = this.app || this.item;
    if (app.disabled) {
      return 'disabled';
    }
    let active = app.from && app.to ? this.isInSeason(app.from, app.to) : true;
    if (this.package.disabledInheritedAppIds && this.package.disabledInheritedAppIds.indexOf(app._id) > -1) {
      return 'disabledInherited';
    }
    if (this.item.disabled || ((this.type === 'installedAppIds' || this.type === 'installedWidgetIds') && this.item.screenDisabled) ||
      ((this.type === 'installedMobileAppIds' || this.type === 'installedMobileWidgetIds') && this.item.mobileDisabled)) {
      return 'disabled';
    }
    return active && !app.disabled ? 'active' : 'paused';
  }

  getClass() {
    return { 'disabled': 'disabled', 'disabledInherited': 'disabled', 'active': 'live', 'paused': 'paused' }[this.checkActive()];
  }

  getTranslation() {
    return {
      'disabled': 'general.publish.disabled', 'disabledInherited': 'general.publish.disabled', 'active': 'general.publish.online', 'paused': 'general.publish.paused'
    }[this.checkActive()];
  }
}
